"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { useQueryClient } from "@tanstack/react-query";
import { logout } from "@/services/auth";
export function useLogout() {
  const $ = _c(3);
  const router = useRouter();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient || $[1] !== router) {
    t0 = async () => {
      await logout();
      queryClient.clear();
      localStorage.removeItem("phonenumber");
      localStorage.removeItem("user-storage");
      router.push("/");
      router.refresh();
    };
    $[0] = queryClient;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}